export default __webpack_public_path__ + "static/media/apo_regenbogen_mono.c16941e0.png";